<quill-view [class]="fontSizeClass()" format="html" [modules]="modules" [content]="content()" [sanitize]="true" />
